export default __webpack_public_path__ + "static/media/ranes7.b9abe3ff.jpg";